import { Icon } from "@iconify/react";
import {
  getProvider,
  Program,
  AnchorProvider,
  web3,
  utils,
  BN,
  setProvider,
} from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { Link } from "react-router-dom";
import {
  getParsedNftAccountsByOwner,
  isValidSolanaAddress,
  createConnectionConfig,
} from "@nfteyez/sol-rayz";
import { useEffect, useState } from "react";
import Footer from "./small/Footer";
import { getParsedAccountByMint } from "@nfteyez/sol-rayz";

const MyNFTs = () => {
  const [walletAddress, setWalletKey] = useState("");
  const [data, setMyNFTS] = useState([]);
  var myNFT = [];
  const topRaffles = [
    {
      firstImg: "../../../assets/images/topraffle/img1.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main2.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main3.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main4.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main5.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main6.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main7.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
    {
      firstImg: "../../../assets/images/topraffle/main8.png",
      profImg: "../../../assets/images/topraffle/img2.png",
      title: "Cyber Girl Smoke ",
      inStock: "8",
      price: "145.55",
      userImg: "../../../assets/images/topraffle/img3.png",
      userName: "Nina Hazel",
    },
  ];
  const opts = {
    preflightCommitment: "processed",
    confirmTransactionInitialTimeout: 90000,
  };

  const getProvider = () => {
    // const connection = new Connection(network, opts.preflightCommitment);
    var connection = new web3.Connection(clusterApiUrl("devnet"), {
      commitment: "confirmed",
      confirmTransactionInitialTimeout: 120000,
    });
    // console.log(connection);
    const provider = new AnchorProvider(
      connection,
      window.solana,
      opts.preflightCommitment
    );
    return provider;
  };

  const provider = getProvider();
  setProvider(provider);
  const onGetAllUserTokens = async () => {
    //Function to get all NFT information.
    //get NFT

    try {
      if (provider.publicKey) {
        // const connect = createConnectionConfig(clusterApiUrl("devnet"));
        const provider = getProvider();
        let ownerToken = provider.publicKey;
        const result = isValidSolanaAddress(ownerToken);
        // console.log("result", result);
        const nfts = await getParsedNftAccountsByOwner({
          publicAddress: ownerToken,
          connection: provider.connection,
          serialization: true,
        });

        // nfts.map((item, index) => {
        //   console.log(item.data.name);
        // });
        console.log(nfts);
        for (var i = 0; i < nfts.length; i++) {
          const removeFirst = nfts[i].data.uri.replace(
            "https://firebasestorage.googleapis.com/v0/b/metamuze-749cc.appspot.com/o/",
            ""
          );
          // console.log(removeFirst);
          var abc = {
            Name: nfts[i].data.name,
            Uri: removeFirst,
            Symbol: nfts[i].data.symbol,
            mintAddress: nfts[i].mint,
            updateAuthority: nfts[i].updateAuthority,
          };
          await fetch(nfts[i].data.uri)
            .then((response) => response.json())
            .then((json) => {
              abc.image = json.image;
              abc.description = json.description;
              abc.timeStamp = json.timeStamp;
              // console.log(abc);
              myNFT.push(abc);
            })
            .catch((err) => {
              console.log(err);
            });
          if (i == nfts.length - 1) {
            let tempData = myNFT;
            await tempData.sort((a, b) => a.timeStamp - b.timeStamp);
            setMyNFTS(tempData);
            console.log(data);
            // setMyNFTS(myNFT);
          }
        }

        return nfts;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    onGetAllUserTokens();
  }, [walletAddress]);

  const walletListner = async () => {
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        // console.log(response.publicKey.toString());

        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  useEffect(() => {
    walletListner();
  }, []);
  useEffect(() => {
    // data.sort((a, b) =>
    //   a.timeStamp.toString().localeCompare(b.timeStamp.toString())
    // );
  }, [data]);
  return (
    <>
      <section className="makeownbanner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12">
              <h3 className="createyourown">
                My
                <span> NFTS </span>
              </h3>
            </div>
          </div>
        </div>
      </section>

      <main id="mynfts" className="whole-main">
        <div className="container">
          <div className="row">
            {data.map((item, index) => {
              return (
                <div
                  className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                  key={index}
                >
                  <Link
                    to={`/nft-detail/${item.Uri}`}
                    style={{ color: "transparent" }}
                  >
                    <div className="top-raffle-single">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src={item?.image}
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src="../../../assets/images/topraffle/img2.png"
                        />

                        <h3 className="raffle-it">{item.Name}</h3>
                      </div>

                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>8</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>{item.price ? item.price : "N/A"}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>

                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src={
                              item.userImg
                                ? item.userImg
                                : "../../../assets/images/topraffle/img3.png"
                            }
                          />

                          <h3 className="seller-name">
                            {item.userName ? item.userName : "Nill"}
                          </h3>
                        </div>
                        <div>
                          {/* <button className="place-bid">"Place a bid"</button> */}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
};
export default MyNFTs;
